module.exports = __webpack_public_path__ + "assets/launch.56f76dfa.svg";